import { getApi } from '../../components/Shared/shared';
const baseURL = getApi();

export const sourcesUrls = {
  outletSources: `${baseURL}/sources/outlet`,
  callCenterSources: `${baseURL}/sources/callcenter/names`
};

export default sourcesUrls;
